/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Chip, Modal, ModalBody, ModalContent, ModalHeader, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, User } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { IconPlus } from '@tabler/icons-react';
import moment from 'moment';
import { Constants, fromPhotos } from '../../../utils';
import { SchoolService } from '../../../services';
import { useSelector } from 'react-redux';
import PaidAction from '../../../components/paid-action';

const Assignments = () => {
  const navigate = useNavigate();
  const [showTeachers, setShowTeachers] = useState(false);
  const { canResetFilter, data, filters, filterBy, grades, goToPage, isLoading, pagination, reload, schoolYears, sections, download } = useFetchTable();

  const currentSection = !!filters.school_section_id
    ? sections.find(x => x.value === filters.school_section_id)?.label
    : '';



  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="sm"
        isOpen={showTeachers}
        onClose={() => setShowTeachers(false)}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          <ModalTeachers filters={filters} grades={grades} sections={sections} teachers={data.teachers} />
        </ModalContent>
      </Modal>

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={() => reload()}
        grades={grades}
        schoolYears={schoolYears}
        sections={sections}
      />

      <Table
        aria-label="Asignaciones"
        color="primary"
        classNames={{
          wrapper: currentSection ? 'gap-0' : '',
          th: currentSection ? '!rounded-t-none' : '',
        }}
        topContentPlacement="inside"
        topContent={
          <div className="flex flex-col gap-4">
            <div className=" flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Asignaciones</h3>
              <div className='flex gap-2'>
                <Button className="bg-green font-medium text-white" onClick={() => navigate('/assignments/create')}>
                  Asignar
                </Button>
                <PaidAction>
                  <Button
                    className="pr-2 bg-green font-medium text-white"
                    endContent={<IconPlus color="white" />}
                    onPress={() => download()}
                  >
                    Descargar
                  </Button>
                </PaidAction>
              </div>
            </div>
            {currentSection && (
              <div className="rounded-t-xl overflow-hidden bg-default-100 text-foreground-500 py-2 px-3 text-lg font-medium flex flex-row justify-start items-center gap-4">
                <span className='capitalize'>{currentSection}</span>
                <Chip
                  className="cursor-pointer"
                  variant="flat"
                  color="primary"
                  onClick={() => setShowTeachers(true)}
                >
                  Profesores
                </Chip>
              </div>
            )}
          </div>
        }
      >
        <TableHeader>
          <TableColumn>Estudiante</TableColumn>
          <TableColumn>DNI/C.I</TableColumn>
          <TableColumn>Teléfono</TableColumn>
          <TableColumn>Correo</TableColumn>
          <TableColumn>Género</TableColumn>
          <TableColumn>Fecha de Nacimiento</TableColumn>
        </TableHeader>
        <TableBody items={data.students} emptyContent="No hay secciones asignadas">
          {(section) => {
            return (
              <TableRow key={section.id}>
                <TableCell>
                  <User
                    avatarProps={{ showFallback: true, radius: 'full', src: section.student?.photo ? fromPhotos(section.student?.photo) : null }}
                    description={section.student?.fullname}
                    name={section?.fullName}
                    classNames={{ description: 'text-foreground-500' }}
                  />
                </TableCell>
                <TableCell>{section.student?.document_type?.name}{section.student?.document}</TableCell>
                <TableCell>{section.student?.phone}</TableCell>
                <TableCell>{section.student?.email}</TableCell>
                <TableCell>{section.student?.gender?.name}</TableCell>
                <TableCell>{moment(section.student?.birthdate).format('DD-MM-YYYY')}</TableCell>
              </TableRow>
            )
          }}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const ModalTeachers = ({ filters, grades, sections, teachers }) => {


  const gradeName = grades.find(x => x.value === filters.school_grade_id)?.label;
  const sectionName = sections.find(x => x.value === filters.school_section_id)?.label;

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Profesores</ModalHeader>
      <ModalBody className="p-0 pb-4 gap-0">
        <h5 className="px-6 pb-2 border-b border-b-gray font-semibold capitalize">{gradeName} - {sectionName}</h5>

        {teachers.map(user => (
          <div className="px-6 py-2 border-b border-b-gray">
            <User
              avatarProps={{ showFallback: true, radius: 'full', src: user.professor?.photo ? fromPhotos(user.professor?.photo) : null }}
              name={user.professor?.fullname}
              classNames={{ description: 'text-foreground-500' }}
            />
          </div>
        ))}
      </ModalBody>
    </>
  )
}

const Filters = ({ canResetFilter, filterBy, grades, resetFilter, schoolYears, sections }) => {
  const initialFilter = {
    school_year_id: '',
    school_grade_id: '',
    school_section_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Select
        label="Año escolar"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
      >
        {schoolYears.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
      <Select
        label="Grado"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
      >
        {grades.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_section_id ? [form.school_section_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_section_id')}
      >
        {sections.map((item) => (
          <SelectItem className='capitalize' key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    school_year_id: '',
    school_grade_id: '',
    school_section_id: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };
  const user = useSelector(state => state.user);
  const [data, setData] = useState({
    students: [],
    teachers: [],
  });
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [schoolYears, setSchoolYears] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);

  const debounceTime = 500;
  const debounce = useRef();

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {
    setData({
      students: [],
      teachers: [],
    });
    if (!canFetch || !filters.school_year_id || !filters.school_grade_id || !filters.school_section_id) return;
    setCanFetch(false);

    try {
      const response = await SchoolService.schoolAssignments.getSectionsAssignment({ ...filters, school_id: user.id });
      const { data, professors, ...rest } = response;

      setData({
        students: data,
        teachers: professors,
      });
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const download = async () => {
    setCanFetch(false);
    try {
      const response = await SchoolService.schoolAssignments.getSectionsAssignment({ ...filters, school_id: user.id, download: true });
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }


  const fetchSchoolYears = async () => {
    try {
      const schoolYearsRes = await SchoolService.schoolAdmin.getSchoolarsYears();
      setSchoolYears(toSelect(schoolYearsRes));
      setCanFetch(true)
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const fetchGrades = async () => {
    if (!filters.school_year_id) return;
    try {
      const grades = await SchoolService.schoolAdmin.getGrades({
        school_id: user.id,
        school_year_id: +filters.school_year_id
      });
      setGrades(toSelect(grades));
      setCanFetch(true)
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const fetchSections = async () => {
    if (!filters.school_grade_id) return;
    try {
      const sections = await SchoolService.schoolAdmin.getSections({
        school_id: user.id,
        school_grade_id: +filters.school_grade_id
      });
      setSections(toSelect(sections));
      setCanFetch(true)
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    fetchSchoolYears()
  }, [])

  useEffect(() => {
    fetchGrades()
  }, [filters.school_year_id])

  useEffect(() => {
    fetchSections()
  }, [filters.school_grade_id])

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filterBy,
    filters,
    goToPage,
    grades,
    isLoading: !canFetch,
    pagination,
    reload,
    schoolYears,
    sections,
    download,
  }
}

export default Assignments;
